import React from 'react';

import { Box, Button, SxProps, Typography } from '@mui/material';

type BlockMenuButtonProps = {
  label: string;
  icon: React.ReactNode;
  onClick: () => void;
};

const BUTTON_SX: SxProps = {
  p: 1.5,
  display: 'flex',
  flexDirection: 'column',
  height: 'auto',
  minHeight: 'unset',
  alignItems: 'stretch',
  textTransform: 'none',
};
const ICON_SX: SxProps = {
  mb: 0.75,
  width: '100%',
  bgcolor: 'cadet.200',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  p: 1,
  border: '1px solid',
  borderColor: 'cadet.300',
  borderRadius: 1,
  minHeight: 40,
};

export default function BlockTypeButton({ label, icon, onClick }: BlockMenuButtonProps) {
  return (
    <Button
      className="email-builder-block-button"
      sx={BUTTON_SX}
      onClick={(ev) => {
        ev.stopPropagation();
        onClick();
      }}
    >
      <Box sx={ICON_SX}>{icon}</Box>
      <Typography variant="body2">{label}</Typography>
    </Button>
  );
}
